export const formatINR = (n) => {
  const num = Number(n || 0);
  if (num >= 1000) return "₹" + num.toLocaleString("en-IN");
  return "₹" + num;
};

export const formatShortMoney = (n) => {
  const num = Number(n || 0);
  if (num >= 1000) return "₹" + (num / 1000).toFixed(num % 1000 === 0 ? 0 : 1) + "k";
  return "₹" + num;
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// "2026-01-15" -> "15 Jan 2026"
export const formatDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = String(iso).split("-");
  if (!y || !m || !d) return iso;
  return `${parseInt(d, 10)} ${MONTHS[parseInt(m, 10) - 1]} ${y}`;
};

export const monthLabel = (iso) => {
  if (!iso) return "";
  const [, m] = String(iso).split("-");
  return MONTHS[parseInt(m, 10) - 1] || "";
};

export const dayNumber = (iso) => {
  if (!iso) return "";
  const [, , d] = String(iso).split("-");
  return parseInt(d, 10);
};

// "10:00" -> "10:00 AM"
export const formatTime = (t) => {
  if (!t) return "";
  const [hh, mm] = String(t).split(":");
  let h = parseInt(hh, 10);
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${mm || "00"} ${ampm}`;
};

export const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
};

// ISO date string for n days from today
export const dateNDaysFromNow = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

export const weekdayShort = (iso) => {
  const d = new Date(iso + "T00:00:00");
  return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][d.getDay()];
};

export const formatGBP = (pence) => {
  const pounds = Number(pence || 0) / 100;
  if (pounds % 1 === 0) return "£" + pounds.toLocaleString("en-GB");
  return "£" + pounds.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
